<template>
  <el-dialog
    :title="choiceId ? '修改员工' : '新增员工'"
    :visible.sync="dialogVisible"
    width="60%"
    v-dialogdrag
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <avue-form
      :option="option"
      v-model="form"
      ref="form"
      :upload-error="uploadError"
      :upload-delete="uploadDelete"
      :upload-before="uploadBefore"
      :upload-after="uploadAfter"
      @submit="formSubmit"
    >
      <template slot="role">
        <el-select v-model="form.role" multiple placeholder="请选择">
          <el-option
            v-for="item in role"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.state == 2 ? true : false"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="headPortrait">
        <FormImgUpload
          :url="form.headPortrait"
          @upload="upload"
          :disabled="false"
          :limit="1"
          :maxSize="20"
          :accept="'.png,.jpg'"
          :multiple="true"
        />
        <div style="color: #c0c1c3">
          建议尺寸：60px*60px，图片格式：.png，.jpg
        </div>
        <!-- <FormImgUpload
          :url="form.headPortrait"
          @upload="upload"
          :disabled='true'
          :limit="1"
          :maxSize="5"
          :accept="'image/png,image/jpg'"
          :multiple="true"
        /> -->
      </template>
      <template slot="menuForm">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submit(form)">确定</el-button>
      </template>
    </avue-form>
  </el-dialog>
</template>

<script>
import { actionUrl, imageUrl } from "@/config/public";
import { userAdd, userUpdate, userView } from "@/api/system/index";
import { emailRegex } from "@/utils/formRules";
import FormImgUpload from "@/components/formComponents/formImgUpload";

export default {
  name: "add",
  props: {
    dialogVisible: Boolean,
    choiceId: String,
  },
  components: {
    FormImgUpload,
  },
  data() {
    return {
      form: {
        headPortrait: [],
        auditPermission: 0,
      },
      role: this.$store.state.system.role,
      parent: [], //归属上级
      option: {
        labelWidth: "120",
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "员工账号",
            prop: "username",
            maxlength: 20,
            // showWordLimit: true,
            placeholder: "请输入",
            row: true,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "员工密码",
            prop: "password",
            maxlength: 20,
            type: "password",
            // showWordLimit: true,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入员工密码",
                trigger: "blur",
              },
            ],
          },
          {
            label: "确认密码",
            type: "password",
            prop: "confrimPassword",
            maxlength: 20,
            // showWordLimit: true,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入确认密码",
                trigger: "blur",
              },
              {
                validator: (_r, value) => {
                  const { password } = this.form;
                  if (password) {
                    const isValid = !!value && value === password;
                    return isValid
                      ? Promise.resolve()
                      : Promise.reject(new Error("密码不一致"));
                  }
                },
              },
            ],
          },
          {
            label: "员工姓名",
            prop: "fullName",
            maxlength: 20,
            row: true,
            // showWordLimit: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入员工姓名",
                trigger: "blur",
              },
            ],
          },
          {
            label: "职位",
            prop: "post",
            maxlength: 20,
            row: true,
            // showWordLimit: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入职位",
                trigger: "blur",
              },
            ],
          },
          {
            label: "头像",
            row: true,
            type: "text",
            prop: "headPortrait",
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传头像",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "员工邮箱",
            prop: "email",
            maxlength: 100,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入员工邮箱",
                trigger: "blur",
              },
              ...emailRegex,
            ],
          },
          {
            label: "员工角色",
            prop: "roleList",
            type: "select",
            dicData: this.$store.state.system.role,
            row: true,
            multiple: true,
            placeholder: "请选择员工角色",
            props: {
              label: "name",
              value: "id",
            },
          },
          {
            label: "状态",
            prop: "state",
            type: "radio",
            row: true,
            dicData: [
              { label: "启用", value: 1 },
              { label: "禁用", value: 2 },
            ],
            rules: [
              {
                required: true,
                message: "请选择状态",
                trigger: "blur",
              },
            ],
          },
          {
            label: "审核权限",
            prop: "auditPermission",
            type: "radio",
            row: true,
            value: 0,
            dicData: [
              { label: "开启", value: 1 },
              { label: "关闭", value: 0 },
            ],
            rules: [
              {
                required: false,
                message: "请选择审核权限",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    if (this.choiceId) {
      userView(this.choiceId).then((res) => {
        this.form = {
          ...res.data,
          headPortrait: [res.data.headPortrait],
          parentId: res.data.parentId == 0 ? "" : res.data.parentId,
          auditPermission:
            res.data.auditPermission !== undefined &&
            res.data.auditPermission !== null
              ? res.data.auditPermission
              : 0,
        };
        // console.log(res.data)
      });
    }
  },
  methods: {
    /**
     * 删除上传文件回调
     * @returns {void}
     */
    uploadDelete() {
      // return this.$confirm(`是否确定移除？`);
    },

    /**
     * 文件上传前的格式校验
     * @param {File} file - 当前上传文件对象
     * @param {Function} done - 放行回调函数
     * @param {Function} loading - 加载停止回调函数
     * @param {Object} column - 当前字段配置
     * @returns {void}
     */
    uploadBefore(file, done, loading, column) {
      if (file.type === "" || column.accept.indexOf(file.type) < 0) {
        this.$message.error("文件格式有误");
        loading();
      } else {
        done();
      }
    },

    /**
     * 文件上传失败处理
     * @param {Error|string} error - 错误信息
     * @param {Object} column - 当前字段配置
     * @returns {void}
     */
    uploadError(error, column) {
      this.$message.error(error);
      // console.log(error, column);
    },

    /**
     * 文件上传成功处理
     * @param {Object} res - 上传响应结果
     * @param {Function} done - 完成回调函数
     * @returns {void}
     */
    uploadAfter(res, done) {
      done();
    },

    /**
     * 关闭弹窗并通知父组件刷新
     * @returns {void}
     */
    handleClose() {
      this.$root.eventHub.$emit("changeAdd", false);
    },

    /**
     * avue-form 内部提交回调
     * @param {Object} form - 表单数据对象
     * @param {Function} done - 完成回调函数
     * @returns {void}
     */
    formSubmit(form, done) {},

    /**
     * 提交保存新增或修改员工信息
     * @param {Object} form - 表单数据对象
     * @returns {void}
     */
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          let that = this;

          if (this.choiceId) {
            userUpdate({
              id: this.choiceId,
              email: form.email,
              fullName: form.fullName,
              headPortrait: form.headPortrait[0],
              username: form.username,
              password: form.password,
              phone: form.phone,
              state: form.state,
              post: form.post,
              auditPermission:
                form.auditPermission !== undefined ? form.auditPermission : 0,
              roleList: form.roleList.toString(),
              parentId: form.parentId || "0",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("修改成功");
                  this.$root.eventHub.$emit("changeAdd", true);
                }
              })
              .catch((err) => {
                that.$message.error(err.msg);
              });
          } else {
            userAdd({
              email: form.email,
              fullName: form.fullName,
              post: form.post,
              headPortrait: form.headPortrait[0],
              username: form.username,
              password: form.password,
              phone: form.phone,
              state: form.state,
              auditPermission:
                form.auditPermission !== undefined ? form.auditPermission : 0,
              roleList: form.roleList.toString(),
              parentId: form.parentId || "0",
            })
              .then((res) => {
                if (res.code === 200) {
                  that.$message.success(res.msg);
                  this.$root.eventHub.$emit("changeAdd", true);
                }
              })
              .catch((err) => {
                that.$message.error(err.msg);
              });
          }
          this.form.type = 1;
        }
      });
    },

    /**
     * 头像上传结果处理并更新表单头像字段
     * @param {string|Array<string>} e - 上传后返回的图片链接
     * @returns {void}
     */
    upload(e) {
      if (Array.isArray(e)) {
        this.form.headPortrait = [...e];
      } else {
        this.form.headPortrait = [...this.form.headPortrait, e];
      }
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog__wrapper {
  z-index: 2003 !important;
}
</style>
